//TODO: LAv inpage search form
e4.search = {
    jSearch: jQuery( '.js-e-search' ),
    init: function () {
        if ( jQuery( '.js-e-search' ).length > 0 ) {
            e4.util.require.js( e4.settings.require.handlebars, function () {
                e4.handlebars.registerHelpers( 'loop compare' );
                e4.search.handlebars.registerHelpers();
                e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-search-result-item-product #js-e-handlebars-tmpl-search-result-item-page #js-e-handlebars-tmpl-search-filters' );
                e4.search.bindEvents();
                e4.search.filters.init();
                if ( e4.util.hash.get( 'search' ) !== undefined ) {
                    jQuery( '.js-e-search-modal' ).filter( ':not(.show)' ).modal( 'show' );
                }
            } );
        }
    },
    bindEvents: function () {
        jQuery( '.js-e-search-modal' ).on( 'shown.bs.modal hide.bs.modal', function ( event ) {
            e4.search.handleModalState( this, event ); 
        } );
        jQuery( '.js-e-search-form' ).on( 'submit', function ( event ) {
            event.preventDefault();
        } );
        jQuery( '.js-e-search-input' ).on( 'keyup input', function ( event ) {
            e4.search.toggleInputGroupState( this, event );
            e4.search.result.get( this, event );
        } ).on( 'change', function () {
            if ( this.value !== '' && e4.util.hash.get( 'search' ) !== undefined ) {
                e4.util.hash.replace( 'search', this.value );
                e4.search.result.track( this, this.value );
            }
        } );
        jQuery( '.js-e-search-clear' ).on( 'click', function () {
            e4.search.clearInput( this );
        } );
        jQuery( window ).on( 'hashchange', function () {
            var hashSearch = e4.util.hash.get( 'search' );
            if ( hashSearch === undefined ) {
                jQuery( '.js-e-search-modal' ).filter( '.show' ).modal( 'hide' );
            }
            else {
                jQuery( '.js-e-search-modal' ).filter( ':not(.show)' ).modal( 'show' );
            }
        } );
    },
    handlebars: {
        registerHelpers: function(){
            Handlebars.registerHelper( 'like', function ( v1, v2, options ) {
                return v1.indexOf(v2) > -1 ? options.fn( this ) : options.inverse( this );
            } );
        }
    },
    loadIndex: function () {
        if ( e4.settings.search.result.pages.show === true ) {
            jQuery.get( e4.settings.search.result.pages.url + ( new Date().getTime() ) );
        }
    },
    handleModalState: function ( domElm, event ) {
        var jSearchInput = jQuery( domElm ).find( '.js-e-search-input' ),
            strQuery = jSearchInput.val(),
            hashSearch = e4.util.hash.get( 'search' );
        if ( event.type === 'shown' ) {
            if ( hashSearch !== undefined && hashSearch !== '' ) {
                jSearchInput.val( hashSearch ).triggerHandler( 'keyup' );
            }
            else if ( strQuery !== '' ) {
                e4.util.hash.set( 'search', strQuery );
                jSearchInput.triggerHandler( 'keyup' );
            }
            else {
                e4.util.hash.set( 'search' );
                e4.search.loadIndex();
            }
            jSearchInput.trigger( 'focus' );
        }
        else {
            jSearchInput.trigger( 'blur' );
            if ( hashSearch !== undefined ) {
                e4.util.hash.remove( 'search' );
                //console.log( 'remove on hash modal hide' );
            }
        }
    },
    toggleInputGroupState: function ( domElm ) {
        var jSearchInputGroup = jQuery( domElm ).closest( '.js-e-search-input-group' );
        if ( domElm.value === '' ) {
            jSearchInputGroup.addClass( 'is-empty' );
        }
        else {
            jSearchInputGroup.removeClass( 'is-empty' );
        }
    },
    clearInput: function ( domElm ) {
        jQuery( domElm ).closest( '.js-e-search-input-group' ).find( '.js-e-search-input' ).val( '' ).trigger( 'focus' ).triggerHandler( 'keyup' );
    },
    result: {
        timeout: null,
        loading: false,
        ready: false,
        count: 0,
        get: function ( domElm ) {
            var strQuery = jQuery.trim( domElm.value );
            if ( e4.search.result.timeout !== null ) {
                clearTimeout( e4.search.result.timeout );
                e4.search.result.timeout = null;
                e4.search.result.loading = false;
            }
            if ( strQuery === '' ) {
                e4.search.result.hide( domElm );
            }
            else if ( strQuery !== domElm.getAttribute( 'data-current-query' ) ) {
                e4.search.result.loading = true;
                var jSearch = jQuery( domElm ).closest( '.js-e-search' );
                jSearch.find( '.js-e-search-result-container' ).addClass( 'is-active' );
                jSearch.find( '.js-e-search-loading-overlay' ).addClass( 'is-loading' );
                e4.search.result.timeout = setTimeout( function () {
                    e4.search.result.ready = false;
                    e4.search.result.count = 0;
                    var selectedFilters = jQuery('.js-e-search-filter:checked').val();
                    domElm.setAttribute( 'data-current-query', strQuery );
                    if ( e4.settings.search.result.pages.show === true ) {
                        e4.search.result.pages.get( domElm, selectedFilters );
                    }
                }, Math.round( Math.max( e4.settings.search.delay.min, e4.settings.search.delay.max / strQuery.length ) ) );
            }
        },
        show: function ( domElm ) {
            //console.log( 'show', e4.search.result.timeout );
            if ( e4.search.result.isReady() === true ) {
                e4.search.result.loading = false;
                e4.search.result.count = e4.search.result.pages.count;
                //console.log( domElm.value, e4.search.result.count, e4.search.result.pages.count, e4.search.result.products.count );
                var jSearch = jQuery( domElm ).closest( '.js-e-search' );
                jSearch.find( '.js-e-search-result-count' ).text( e4.search.result.count );
                jSearch.find( '.js-e-search-loading-overlay' ).removeClass( 'is-loading' );
            }
        },
        hide: function ( domElm ) {
            jQuery( domElm ).closest( '.js-e-search' ).find( '.js-e-search-result-container' ).removeClass( 'is-active' );
            e4.search.result.pages.hide( domElm );
        },
        isReady: function () {
            return ( ( e4.search.result.pages.ready === true || e4.settings.search.result.pages.show === false ) );
        },
        isLoading: function () {
            return ( e4.search.result.ready === false || e4.search.result.loading === true );
        },
        track: function ( domElm, strQuery ) {
            // console.log( '---------------' );
            // console.log( 'strQuery', strQuery );
            // console.log( 'domElm.getAttribute( data-current-query )', domElm.getAttribute( 'data-current-query' ) );
            // console.log( 'e4.search.result.ready', e4.search.result.ready );
            // console.log( 'e4.search.result.count', e4.search.result.count );
            // console.log( 'e4.search.result.isLoading()', e4.search.result.isLoading(), e4.search.result.timeout );
            if ( e4.search.result.isLoading() === true ) {
                //console.log( 'track timeout', strQuery );
                setTimeout( function () {
                    e4.search.result.track( domElm, strQuery );
                }, 100 );
            }
            else if ( strQuery === domElm.getAttribute( 'data-current-query' ) ) {
                //console.log( 'track query', strQuery );
                e4.gtm.pushDataLayer( {
                    'event': 'VirtualPageviewSearch',
                    'virtualPageSearchURL': '/search?q=' + strQuery,
                    'virtualPageSearchTitle': 'Search'
                } );
                if ( e4.search.result.count === 0 ) {
                    //console.log( 'track no results', strQuery );
                    e4.gtm.pushDataLayer( {
                        'eventCategory': 'Nulsøgning',
                        'eventAction': strQuery,
                        'eventLabel': '{{Page URL}}',
                        'eventValue': 0,
                        'eventInteraction': true,
                        'event': 'track-ga-event'
                    } );
                }
            }
        },
        pages: {
            ready: false,
            count: 0,
            get: function ( domElm, type ) {
                e4.search.result.pages.ready = false;
                e4.search.result.pages.count = 0;
                var jType = '';
                if (type != undefined) {
                    jType = '&type='+ type;
                }
                jQuery.getJSON( e4.settings.search.result.pages.url + encodeURIComponent(domElm.value) + jType, function ( data ) {
                    //console.log('pages', domElm.getAttribute( 'data-current-query' ), data.q);
                    if ( domElm.getAttribute( 'data-current-query' ) === data.q ) {
                        e4.search.result.pages.ready = true;
                        e4.search.result.ready = e4.search.result.isReady();
                        e4.search.result.pages.count = data.pages.length;
                        e4.search.result.pages.show( domElm, data );
                        e4.search.result.show( domElm );
                    }
                } );
            },
            show: function ( domElm, data ) {
                var jSearch = jQuery( domElm ).closest( '.js-e-search' );
                if ( e4.search.result.pages.count > 0 ) {
                    jSearch.find( '.js-e-search-result-pages' ).html( e4.handlebars.tmpl.searchResultItemPage( data ) ).removeClass( 'is-empty' );
                    jSearch.find( '.js-e-search-result-filters' ).html( e4.handlebars.tmpl.searchFilters( data ) ).removeClass( 'is-empty' );
                }
                else {
                    e4.search.result.pages.hide( domElm );
                }
            },
            hide: function ( domElm ) {
                var jSearch = jQuery( domElm ).closest( '.js-e-search' );
                jSearch.find( '.js-e-search-result-pages' ).addClass( 'is-empty' ).html( '' );
                jSearch.find( '.js-e-search-result-filters' ).addClass( 'is-empty' ).html( '' );
            }
        }
    },
    filters: {
        init: function () {
            e4.search.filters.bindEvents();
            e4.search.filters.collapse.init();
        },
        bindEvents: function () {
            e4.search.jSearch.on( 'change', '.js-e-search-filter', function () {
                e4.search.filters.applyFilters( this );
            } );
            // Følgende bør enrettes i navngivning. clear, remove, med eller uden group?
            e4.search.jSearch.on( 'click', '.js-e-search-filters-remove', function ( event ) {
                event.preventDefault();
                e4.search.filters.removeFilter( this );
            } );
            jQuery( document ).on( 'click', '.js-e-search-filters-clear-all', function ( event ) {
                event.preventDefault();
                e4.search.filters.resetAll();
            } );
            e4.search.jSearch.on( 'change', '.js-e-search-filters-option-reset-group', function ( event ) {
                event.preventDefault();
                if ( jQuery( this ).is( ':checked' ) === true ) {
                    e4.search.filters.resetGroup( this );
                }
                else {
                    jQuery( this ).prop( 'checked', true );
                }
            } );

            e4.search.jSearch.on( 'click', '.js-e-search-filters-options-collapse-peek-toggle', function ( event ) {
                event.preventDefault();
                e4.search.filters.collapse.peek.toggle( this );
            } );

        },
        refresh: function () {
            e4.search.filters.collapse.init();
        },
        applyFilters: function ( domElm ) {
            var jThis = jQuery( domElm );
            var jSearchInput = jQuery('.js-e-search-input')[ 0 ];
            jThis.closest( '.js-e-search-filters-group' ).find( '.js-e-search-filters-option-reset-group' ).prop( 'checked', false );
            if ( jThis.is( ':checked' ) === false ) {
                var checkedLength = jThis.closest( '.js-e-search-filters-group' ).find( '.js-e-search-filter' ).filter( ':checked' ).length;
                if ( checkedLength === 0 ) {
                    jThis.closest( '.js-e-search-filters-group' ).find( '.js-e-search-filters-option-reset-group' ).prop( 'checked', true );
                }
            }

            jQuery( 'input[name="PageNum"]' ).val( 1 );
            e4.search.result.pages.get( jSearchInput, jThis.val() );
        },
        removeFilter: function ( domElm ) {
            var strValue = jQuery( domElm ).data( 'value' );
            var jSearchInput = jQuery('.js-e-search-input')[ 0 ];
            e4.search.jSearch.find( '.js-e-search-filter[value="' + strValue + '"]' ).prop( 'checked', false );
            e4.search.result.pages.get( jSearchInput, strValue );
        },
        resetGroup: function ( domElm ) {
            var jSearchInput = jQuery('.js-e-search-input')[ 0 ];
            jQuery( domElm ).closest( '.js-e-search-filters-group' ).find( '.js-e-search-filter' ).prop( 'checked', false );
            e4.search.result.pages.get( jSearchInput, '' );
        },
        resetAll: function () {
            var jSearchInput = jQuery('.js-e-search-input')[ 0 ];
            jQuery( 'input[name="PageNum"]' ).val( 1 );
            e4.search.jSearch.find( '.js-e-search-filter' ).prop( 'checked', false );
            e4.search.jSearch.find( '.js-e-search-input' ).val( '' );
            e4.search.result.pages.get( jSearchInput, '' );
        },
        collapse: {
            init: function () {
                jQuery( '.js-e-search-filters-group-options' ).each( function () {
                    var jThis = jQuery( this ),
                        jPeekable = jThis.find( '.js-e-search-filters-options-collapse-peek' );
                    if ( jThis.is( '.collapse' ) === true ) {
                        jThis.addClass( 'show' );
                    }
                    if ( jPeekable.length === 1 ) {
                        e4.search.filters.collapse.peek.setHeight( jPeekable );
                    }
                    if ( jThis.is( '.is-expanded' ) === false ) {
                        jThis.removeClass( 'show' );
                    }
                } );
            },
            peek: {
                setHeight: function ( jPeekable ) {
                    var jFilterOptions = jPeekable.find( '.js-e-search-filters-option' ),
                        intPeekOptionCount = parseInt( jQuery( '.js-e-visible-options-count' ).val() ) + 1.5,
                        intHeightPeek = Math.ceil( jFilterOptions.first().outerHeight() ) * intPeekOptionCount,
                        intHeightInitial = jPeekable.get( 0 ).scrollHeight,
                        intHeightToggleButton = jPeekable.find( '.js-e-search-filters-options-collapse-peek-toggle' ).outerHeight();
                    if ( jFilterOptions.filter( '.is-selected' ).length === 0 && jFilterOptions.length > intPeekOptionCount && intHeightInitial > intHeightPeek * e4.settings.collapse.peekSizeMin ) {
                        // console.log( domElm, domElm.scrollHeight );
                        jPeekable.data( {
                            'height-peek': intHeightPeek + intHeightToggleButton,
                            'height-initial': intHeightInitial + intHeightToggleButton,
                        } );
                        jPeekable.addClass( 'is-peeking' );
                        jPeekable.css( 'max-height', jPeekable.data( 'height-peek' ) );
                    }
                    else {
                        jPeekable.removeClass( 'e-search-filters-options-collapse-peek is-peeking' );
                        jPeekable.find( '.js-e-search-filters-options-collapse-peek-toggle' ).remove();
                    }
                },
                toggle: function ( domElm ) {
                    var jPeekable = jQuery( domElm ).closest( '.js-e-search-filters-options-collapse-peek' );
                    if ( jPeekable.is( '.is-peeking' ) === true ) {
                        jPeekable.removeClass( 'is-peeking' );
                        jPeekable.css( 'max-height', jPeekable.data( 'height-initial' ) );
                    }
                    else {
                        jPeekable.addClass( 'is-peeking' );
                        jPeekable.css( 'max-height', jPeekable.data( 'height-peek' ) );
                    }
                }
            }
        }
    }
};

